import { Component, OnInit, OnDestroy } from "@angular/core";
import { DataService_express } from "../shared/data.service";
import { formatDate } from "@angular/common";

import { wsOneCardExpressPopupDataAddInfo } from "../shared/wsOneCardExpressPopupDataAddInfo";
import { wsIDDepotPrintReasonInfo } from "../shared/wsOneCardExpressPopupDataAddInfo";
import { wsMTAOverrideReasonInfo } from "../shared/wsOneCardExpressPopupDataAddInfo";
import { wsMTAOverrideToggleParm } from "../shared/wsMTAOverrideToggleParm";
import { wsPrintQueueInsertParm } from "../shared/wsPrintQueueInsertParm";

import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";

@Component({
	selector: "app-root",
	templateUrl: "./add.component.html",
	styleUrls: ["./add.component.css"],
})
export class AddComponent implements OnInit, OnDestroy {
	constructor(private dataService: DataService_express, public ref: DynamicDialogRef, public dialogConfig: DynamicDialogConfig) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;

	public UserPersonID: number;
	public SchoolID: number;
	public PersonID: number;
	public StudentID: string;
	public PersonName: string;
	public EnableOverrideMode: boolean;
	public EnableReprintMode: boolean;
	public IsMTARider: boolean;

	public DistrictMTAOverridePolicy: string;

	public rOneCardExpressPopupData: wsOneCardExpressPopupDataAddInfo;

	public lstOverrideReason: wsMTAOverrideReasonInfo[] = [];
	public SelectedOverrideReason: wsMTAOverrideReasonInfo;

	public lstPrintReason: wsIDDepotPrintReasonInfo[] = [];
	public SelectedPrintReason: wsIDDepotPrintReasonInfo;

	public ErrorMessage: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.isBusy = true;

		this.UserPersonID = this.dialogConfig.data.UserPersonID;
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.PersonID = this.dialogConfig.data.PersonID;
		this.StudentID = this.dialogConfig.data.StudentID;
		this.PersonName = this.dialogConfig.data.PersonName;
		this.EnableOverrideMode = this.dialogConfig.data.EnableOverrideMode;
		this.EnableReprintMode = this.dialogConfig.data.EnableReprintMode;
		this.IsMTARider = this.dialogConfig.data.IsMTARider;

		this.isBusy = true;
		this.dataService.OneCardExpressPopupDataAddGet(this.SchoolID).subscribe((data) => this.OneCardExpressPopupDataAddGet_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	OneCardExpressPopupDataAddGet_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	OneCardExpressPopupDataAddGet_Complete(data: any) {
		this.rOneCardExpressPopupData = data;

		this.DistrictMTAOverridePolicy = this.rOneCardExpressPopupData.DistrictMTAOverridePolicy;
		this.lstPrintReason = this.rOneCardExpressPopupData.IDDepotPrintReasonItems;
		this.lstOverrideReason = this.rOneCardExpressPopupData.MTAOverrideReasonItems;

		this.SelectedPrintReason = this.lstPrintReason[0];
		this.SelectedOverrideReason = this.lstOverrideReason[0];

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPrintReasonChange
	//
	//-----------------------------------------------------------------------------------------------------
	onPrintReasonChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onOverrideReasonChange
	//
	//-----------------------------------------------------------------------------------------------------
	onOverrideReasonChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAgree
	//
	//-----------------------------------------------------------------------------------------------------
	onAgree() {
		if (this.EnableOverrideMode == true && this.SelectedOverrideReason.MTAOverrideReasonID < 0) {
			this.ErrorMessage = "Please select an Override Reason.";
			return;
		}

		if (this.EnableReprintMode == true && this.SelectedPrintReason.IDDepotPrintReasonID < 0) {
			this.ErrorMessage = "Please select a Reprint Reason.";
			return;
		}

		if (this.EnableOverrideMode == true) {
			let parms: wsMTAOverrideToggleParm = {
				PersonID: this.PersonID,
				MTAOverrideReasonID: this.SelectedOverrideReason.MTAOverrideReasonID,
				AdministratorPersonID: this.UserPersonID,
			};

			this.isBusy = true;
			this.dataService.MTAOverrideToggle(parms).subscribe((data) => this.MTAOverrideToggle_Complete(data));
		} else {
			this.AddToQueue();
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	MTAOverrideToggle_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	MTAOverrideToggle_Complete(data: any) {
		this.AddToQueue();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AddToQueue
	//
	//-----------------------------------------------------------------------------------------------------
	AddToQueue() {
		let IDDepotPrintReasonID: number = 11; // New Card

		if (this.EnableReprintMode == true) {
			IDDepotPrintReasonID = this.SelectedPrintReason.IDDepotPrintReasonID;
		}

		let parms: wsPrintQueueInsertParm = {
			PersonID: this.PersonID,
			IDDepotPrintReasonID: IDDepotPrintReasonID,
			AdministratorPersonID: this.UserPersonID,
		};

		this.isBusy = true;
		this.dataService.IDPrintQueueAdd(parms).subscribe((data) => this.IDPrintQueueAdd_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintQueueAdd_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintQueueAdd_Complete(data: any) {
		this.isBusy = false;

		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(1);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
